import APP_CONST from '@/constants/AppConst'
import APP_UTILITIES from '@/utilities/commonFunctions'

export const guardianInformation = {
  getScholar: () => {
    const date: any = new Date()
    const key = new Date().getTime() + '_' + Math.ceil(Math.random() * 99999)
    const states: any = APP_UTILITIES.getStatesShortFinalList(APP_CONST.COUNTRY_ID)

    return [
      {
        group: 'guardianDetails',
        type: 'guardianName',
        name: 'guardianName',
        title: 'Name',
        elmType: 'grid',
        label: 'Guardian Name',
        dropIndex: 0,
        columns: [
          {
            span: 12,
            list: [
              {
                type: 'input',
                name: 'guardian_firstname',
                title: 'First Name',
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'First Name',
                  disabled: false,
                  maxLength: 50
                },
                key: key + '_guardian_firstname',
                model:
                  'guardian_firstname' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  { type: 'string', message: 'First Name Invaild format' },
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    pattern: "/^[a-zA-Z '-]+$/",
                    message:
                      'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                  },
                  {
                    min: 0,
                    max: 50,
                    message: 'Firstname must be 0 to 50 charactors',
                    trigger: 'blur'
                  }
                ],
                isDrag: false,
                isEditable: false
              }
            ]
          },
          {
            span: 12,
            list: [
              {
                type: 'input',

                name: 'guardian_lastname',
                title: 'Last Name',
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Last Name',
                  disabled: false,
                  maxLength: 50
                },
                key: key + '_guardian_lastname',
                model:
                  'guardian_lastname' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  { type: 'string', message: 'Last Name Invaild format' },
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    pattern: "/^[a-zA-Z '-]+$/",
                    message:
                      'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                  },
                  {
                    min: 0,
                    max: 50,
                    message: 'Lastname must be 0 to 50 charactors',
                    trigger: 'blur'
                  }
                ],
                isDrag: false,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_guardianName',
        model: 'guardianName' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'guardianDetails',
        type: 'input',
        name: 'guardian_birthdate',
        title: 'Birth Date',
        dropIndex: 0,
        elmType: 'single',
        label: 'Guardian Birth Date',
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'MM-DD-YYYY',
          disabled: false,
          maxLength: 14
        },
        key: key + '_guardian_birthdate',
        model:
          'guardian_birthdate' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          {
            required: true,
            message:
              'Be sure to enter MM-DD-YYYY. (Asegúrate de escribir la fecha de nacimiento (mes, día, año) MM-DD-AAAA)'
          }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'guardianDetails',
        type: 'dropdown',

        name: 'guardian_relation',
        title: 'Relationship to Child',
        label: 'Guardian Relationship to Child',
        elmType: 'custom',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Mother'
            },
            {
              value: 'Father'
            },
            {
              value: 'Grandparent'
            },
            {
              value: 'Other'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_guardian_relationship',
        model:
          'guardian_relationship' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'guardianDetails',
        type: 'checkbox',

        name: 'guardian_primary',
        title: 'Primary Guardian',
        elmType: 'single',
        label: 'Primary Guardian',
        dropIndex: 0,
        options: {
          inline: false,
          defaultValue: false,
          showLabel: false,
          options: [
            {
              value: 'Are you the primary guardian?'
            }
          ],
          required: false,
          width: '',
          remote: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: '',
          disabled: false
        },
        key: key + '_primary_guardian',
        model:
          'primary_guardian' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'guardianDetails',
        type: 'input',

        name: 'guardian_email',
        title: 'Email',
        elmType: 'single',
        label: 'Guardian Email',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Email',
          disabled: false,
          maxLength: 254
        },
        key: key + '_guardian_email',
        model:
          'guardian_email' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          {
            type: 'email',
            message:
              'Enter a valid email address. (Escribe una dirección válida de correo electrónico, (email).)'
          },
          {
            required: true,
            message:
              'Enter a valid email address. (Escribe una dirección válida de correo electrónico, (email).)'
          }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'guardianDetails',
        type: 'phoneNumberType',
        name: 'guardianPhoneNumberType',
        title: 'Phone Number',
        elmType: 'grid',
        label: 'Guardian Phone Number',
        dropIndex: 0,
        columns: [
          {
            span: 12,
            list: [
              {
                type: 'input',
                name: 'guardian_phone',
                title: 'Phone',
                elmType: 'single',
                label: 'Phone Number',
                dropIndex: 0,
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Enter Number',
                  disabled: false,
                  maxLength: 14
                },
                key: key + '_guardian_phonenumber',
                model:
                  'guardian_phonenumber' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    min: 14,
                    max: 14,
                    message: 'Phone number must be of 10 digits',
                    trigger: 'blur'
                  }
                ],
                isDrag: true,
                isEditable: false
              }
            ]
          },
          {
            span: 12,
            list: [
              {
                type: 'select',
                name: 'guardian_phonetype',
                title: 'Type',
                elmType: 'single',
                dropdownStatus: false,
                options: {
                  defaultValue: 'Select',
                  multiple: false,
                  disabled: false,
                  clearable: false,
                  placeholder: '',
                  required: false,
                  showLabel: false,
                  width: '',
                  options: [
                    {
                      value: 'Cell'
                    },
                    {
                      value: 'Work'
                    },
                    {
                      value: 'Home'
                    }
                  ],
                  remote: false,
                  filterable: false,
                  remoteOptions: [],
                  props: {
                    value: 'value',
                    label: 'label'
                  },
                  remoteFunc: ''
                },
                key: key + '_guardian_phoneNumber_type',
                model:
                  'guardian_phoneNumber_type' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: true,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_guardianPhoneNumberType',
        model:
          'guardianPhoneNumberType' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'guardianDetails',
        type: 'phoneNumberType',
        name: 'guardianSecondaryPhoneNumberType',
        title: 'Secondary Phone',
        elmType: 'grid',
        label: 'Guardian Secondary Phone',
        dropIndex: 0,
        columns: [
          {
            span: 12,
            list: [
              {
                type: 'input',
                name: 'guardian_secondary_phone',
                title: 'Phone',
                elmType: 'single',
                label: 'Phone Number',
                dropIndex: 0,
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Enter Number',
                  disabled: false,
                  maxLength: 14
                },
                key: key + '_guardian_secondary_phonenumber',
                model:
                  'guardian_secondary_phonenumber' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    min: 14,
                    max: 14,
                    message: 'Phone number must be of 10 digits',
                    trigger: 'blur'
                  }
                ],
                isDrag: true,
                isEditable: false
              }
            ]
          },
          {
            span: 12,
            list: [
              {
                type: 'select',
                name: 'guardian_secondarytype',
                title: 'Type',
                elmType: 'single',
                dropdownStatus: false,
                options: {
                  defaultValue: 'Select',
                  multiple: false,
                  disabled: false,
                  clearable: false,
                  placeholder: '',
                  required: false,
                  showLabel: false,
                  width: '',
                  options: [
                    {
                      value: 'Cell'
                    },
                    {
                      value: 'Work'
                    },
                    {
                      value: 'Home'
                    }
                  ],
                  remote: false,
                  filterable: false,
                  remoteOptions: [],
                  props: {
                    value: 'value',
                    label: 'label'
                  },
                  remoteFunc: ''
                },
                key: key + '_guardian_secondary_phoneNumber_type',
                model:
                  'guardian_secondary_phoneNumber_type' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: true,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_guardianSecondaryPhoneNumberType',
        model:
          'guardianSecondaryPhoneNumberType' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'guardianDetails',
        type: 'guardianaddressField',
        name: 'guardianaddressField',
        dropIndex: 0,
        title: 'Address',
        elmType: 'addressGrid',
        label: 'Guardian Address',
        columns: [
          {
            span: 24,
            list: [
              {
                type: 'input',
                name: 'guardian_address1',
                title: 'Address Line 1',
                elmType: 'single',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Address Line 1',
                  disabled: false
                },
                key: key + '_guardian_address1',
                model:
                  'guardian_address1' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: false,
                isEditable: false
              },
              {
                type: 'input',
                name: 'guardian_address2',
                title: 'Address Line 2',
                elmType: 'single',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Address Line 2',
                  disabled: false
                },
                key: key + '_guardian_address2',
                model:
                  'guardian_address2' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: false,
                isEditable: false
              },
              {
                elmType: 'grid',
                columns: [
                  {
                    span: 8,
                    list: [
                      {
                        type: 'input',
                        name: 'guardian_city',
                        title: 'City',
                        elmType: 'single',
                        options: {
                          isHide: false,
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'City',
                          disabled: false
                        },
                        key: key + '_guardian_city',
                        model:
                          'guardian_city' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 8,
                    list: [
                      {
                        type: 'select',

                        name: 'guardian_state',
                        title: 'State',
                        elmType: 'single',
                        dropdownStatus: false,
                        options: {
                          isHide: false,
                          defaultValue: 'State',
                          multiple: false,
                          disabled: false,
                          clearable: false,
                          placeholder: '',
                          required: false,
                          showLabel: false,
                          width: '',
                          options: (function () {
                            const arr = []
                            for (const state of states) {
                              arr.push({ value: state })
                            }
                            return arr
                          })(),
                          remote: false,
                          filterable: false,
                          remoteOptions: [],
                          props: {
                            value: 'value',
                            label: 'label'
                          },
                          remoteFunc: ''
                        },
                        key: key + '_guardian_state',
                        model:
                          'guardian_state' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [],
                        isDrag: true,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 8,
                    list: [
                      {
                        type: 'input',
                        name: 'guardian_zipcode',
                        title: 'Postal Code',
                        elmType: 'single',
                        options: {
                          isHide: false,
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'ZIP Code',
                          disabled: false,
                          maxLength: 5
                        },
                        key: key + '_guardian_zipcode',
                        model:
                          'guardian_zipcode' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [
                          {
                            pattern: '/^[0-9]*$/',
                            message: 'Be sure to enter all 5 digits(Escribe los 5 números.)',
                            trigger: 'change'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  }
                ],
                options: {
                  gutter: 0,
                  justify: 'start',
                  align: 'top'
                }
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_guardianaddressField',
        model:
          'guardianaddressField' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'guardianDetails',
        type: 'dropdown',
        name: 'guardian_language',
        title: 'Language at Home',
        label: 'Guardian Language at Home',
        elmType: 'custom',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Spanish'
            },
            {
              value: 'Chinese (Mandarin)'
            },
            {
              value: 'Chinese (Cantonese)'
            },
            {
              value: 'Tagalog'
            },
            {
              value: 'Vietnamese'
            },
            {
              value: 'Arabic'
            },
            {
              value: 'French & French Creole'
            },
            {
              value: 'Korean'
            },
            {
              value: 'Russian'
            },
            {
              value: 'German'
            },
            {
              value: 'Haitian Creole'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_guardian_language',
        model:
          'guardian_language' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      }
    ]
  }
}
